import { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';
import { usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation, } from 'ab-tests-api';
/**
 * This hook is used to assign an AB variant to a test and persist the data in cookies for 7 days.
 * @param testSlug - The slug of the test to assign.
 * @returns An object with the assignABVariant function, the data, the loading state, and the error state.
 */
function useABTest(testSlug) {
    const [data, setData] = useState(null);
    const [assignVariant, { isLoading, error }] = usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation();
    const [cookies, setCookie] = useCookies([testSlug]);
    const assignVariantWrapper = useCallback(async () => {
        const SEVEN_DAYS_FROM_NOW = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
        const cachedData = cookies[testSlug];
        if (!cachedData) {
            // Call the API to assign a variant and persist the data in cookies for 7 days.
            const data = await assignVariant({
                testSlug,
                postAbTestsV1ParticipantsAssignVariantTestSlug: {},
            }).unwrap();
            setData(data);
            setCookie(testSlug, data, {
                expires: SEVEN_DAYS_FROM_NOW,
            });
        }
        else {
            // Use the unexpired cached data.
            setData(cachedData);
        }
    }, [assignVariant, testSlug, cookies, setCookie]);
    return { assignABVariant: assignVariantWrapper, data, isLoading, error };
}
export default useABTest;
